module.exports = __webpack_public_path__ + "media/mail/fa-twitter-703a1c45.png";